import { render } from "./PaymentProcessing.vue?vue&type=template&id=37372010"
import script from "./PaymentProcessing.vue?vue&type=script&lang=js"
export * from "./PaymentProcessing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__